// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contractObligationEntity from './entities/contract-obligation.json';
import contractObligationMenu from '../pages/contract-obligation/menu.json';
import contractObligationFullForm from '../pages/contract-obligation/forms/full.json';
import contractObligationContextForm from '../pages/contract-obligation/forms/context.json';
import contractObligationMiniForm from '../pages/contract-obligation/forms/mini.json';
import contractObligationLookupForm from '../pages/contract-obligation/forms/lookup.json';
import contractObligationTableView from '../pages/contract-obligation/views/table.json';
import contractObligationCardsView from '../pages/contract-obligation/views/cards.json';
import contractObligationCalendarView from '../pages/contract-obligation/views/calendar.json';
import contractObligationDashboardView from '../pages/contract-obligation/views/dashboard.json';

/** Тип запису «Зобов’язання» зі сторінками пакета: меню, форми та подання з pages/contract-obligation/. */
export const contractObligationDefinition: IRecordTypeDefinition = {
  ...contractObligationEntity,
  views: assembleViewSet({
      table: contractObligationTableView,
      cards: contractObligationCardsView,
      calendar: contractObligationCalendarView,
      dashboard: contractObligationDashboardView,
  }),
  form: contractObligationFullForm,
  forms: { full: contractObligationFullForm, context: contractObligationContextForm, mini: contractObligationMiniForm, lookup: contractObligationLookupForm },
  menu: contractObligationMenu,
} as IRecordTypeDefinition;
